import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map, shareReplay, withLatestFrom } from 'rxjs/operators';

import { getCountryCode, getCountryGroupsName, getXConfigValue } from '@core/infrastructure/state/core.selectors';

// [TechDebt] - Este servicio no tiene nada que ver con API ni debería estar en root, mover a su propio modulo feature
@Injectable({
    providedIn: 'root',
})
export class CountryService {
    private readonly countryCode$: Observable<string> = this.store.select(getCountryCode)
        .pipe(
            filter((countryCode) => !!countryCode),
            first(),
        );

    private readonly wwCountryIsos = getXConfigValue('WEB_WW_COUNTRY_ISOS');

    private readonly wwCountryGroupName = getCountryGroupsName();

    constructor(private readonly store: Store) {}

    /**
     * Devuelve una cadena con la lista con los códigos de los grupos de paises worldwide: WW, WA, WE ...
     */
    public getWorldWideCountries$: Observable<string> = this.store.select(this.wwCountryIsos).pipe(
        map((data: string) => data ?? ''),
        // eslint-disable-next-line rxjs/no-ignored-replay-buffer
        shareReplay(),
    );

    /**
     * Devuelve true si:
     * En el selector ww no seleccionamos ningun país y le damos a men/woman, no hay pais definido
     * Ejemplo: Si es ww, al crear una direccion de shipping el input country sera libre y editable
     */
    public isWWStore$: Observable<boolean> = combineLatest([this.countryCode$, this.getWorldWideCountries$]).pipe(
        map(([countryCode, wwCountries]) => {
            return wwCountries.split(',').includes(countryCode);
        }),
        // eslint-disable-next-line rxjs/no-ignored-replay-buffer
        shareReplay(),
    );

    /**
     * Devuelve true si:
     * Seleccionamos un pais worldwide en el selector, un pais que forma parte de uno de los grupos worldwide: WW, WA, WE
     * Ejemplo: Si es un pais ww(Argentina), al crear una direccion de shipping el input country no sera editable sino que aparecera el pais seleccionado no editable (Argentina)
     */
    public isWWCountry$: Observable<boolean> = this.getWorldWideCountries$.pipe(
        withLatestFrom(
            this.store.select(this.wwCountryGroupName),
        ),
        map(([wwCountries, countryGroupName]) => {
            return wwCountries.split(',').includes(countryGroupName);
        }),
    );
}
